module.exports = __webpack_public_path__ + "media/BG03.9df746ee.mp4";